class CgVideoHover extends HTMLElement {
  connectedCallback() {
    this._carousel = this.querySelector('.video-feedback__carousel');
    if (!this._carousel) return;
    this._onCarouselChange = () => {
      this._carousel.querySelectorAll('xo-carousel-slide').forEach(slide => {
        const item = slide.querySelector('.video-feedback__item');
        if (!item) return;
        slide.hasAttribute('xo-center') ? this._playVideo(item) : this._pauseVideo(item);
      });
    };
    this._carousel.addEventListener('xo:carousel:change', this._onCarouselChange);
    this._setupIntersectionObserver();
  }

  disconnectedCallback() {
    this._initObserver?.disconnect();
    this._intersectionObserver?.disconnect();
    this._carousel?.removeEventListener('xo:carousel:change', this._onCarouselChange);
  }

  _getVideo(cover) {
    // xo-video-cover.init() appends the real playing video inside xo-video-cover-item.
    // The Liquid video_tag element is the first <video> but is visually covered — target the right one.
    return cover?.querySelector('xo-video-cover-item video') ?? cover?.querySelector('video');
  }

  _playVideo(item) {
    const cover = item.querySelector('xo-video-cover');
    const video = this._getVideo(cover);
    if (!cover || !video) return;
    cover.removeAttribute('xo-paused');
    cover.setAttribute('xo-playing', '');
    video.play().catch(() => {});
  }

  _pauseVideo(item) {
    const cover = item.querySelector('xo-video-cover');
    const video = this._getVideo(cover);
    if (!cover || !video) return;
    cover.removeAttribute('xo-playing');
    cover.setAttribute('xo-paused', '');
    video.pause();
  }

  _pauseAll() {
    this.querySelectorAll('.video-feedback__item').forEach(item => this._pauseVideo(item));
  }

  _setupIntersectionObserver() {
    this._intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this._syncInitialState();
        } else {
          this._initObserver?.disconnect();
          this._initObserver = null;
          this._pauseAll();
        }
      });
    }, { threshold: 0.1 });
    this._intersectionObserver.observe(this);
  }

  _syncInitialState() {
    if (this._carousel.querySelector('xo-carousel-slide[xo-center]')) {
      this._onCarouselChange();
      return;
    }
    // xo-carousel-list has a 100ms async delay before setting xo-center — observe for it
    this._initObserver = new MutationObserver(() => {
      if (this._carousel.querySelector('xo-carousel-slide[xo-center]')) {
        this._initObserver.disconnect();
        this._initObserver = null;
        this._onCarouselChange();
      }
    });
    this._initObserver.observe(this._carousel, { subtree: true, attributeFilter: ['xo-center'] });
  }
}

customElements.define('cg-video-hover', CgVideoHover);
